import Loader from './Loader';
export type { LoaderProps } from './Loader.types';

export default Loader;
